function getGridPosition(value) {
  let result;
  switch (value) {
    case "top":
    case "left": {
      result = "start";
      break;
    }
    case "middle": {
      result = "center";
      break;
    }
    case "between": {
      result = "space-between";
      break;
    }
    case "right":
    case "bottom": {
      result = "end";
      break;
    }
  }
  return result;
}

export { getGridPosition };
